import React from 'react'
import NotFoundIllustration from "../Files/NotFound.svg"
import { Link } from 'react-router-dom';

interface Props { }

function NotFound(props: Props) {
    const { } = props

    return (
        <div style={{ position: "absolute", width: "100%", height: "100%", color: "white" }} >
            <div className='contain-load' >
                <img draggable={false} width={"50%"} src={NotFoundIllustration} alt="" />
                <center >
                    <label htmlFor="" style={{ color: "rgba(255, 255, 255, .5)", fontSize: "200%" }}>Page indisponible</label><br /><br />
                    <Link style={{color: "white", outline: "none", textDecoration: "none", background: "rgba(255, 255, 255, .1)", padding: "10px", borderRadius: "5px"}} to={"/"}>Retour à l'acceuil</Link>
                </center>

            </div>
        </div>
    )
}

export default NotFound
